import React from 'react';
import { motion } from 'framer-motion';
import Hero from './components/Hero';
import ValueStrip from './components/ValueStrip';
import Benefits from './components/Benefits';
import Features from './components/Features';
import Process from './components/Process';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import LeadForm from './components/LeadForm';
import FloatingCTA from './components/FloatingCTA';
import TitleBar from './components/TitleBar';
import Navigation from './components/Navigation';

function App() {
  return (
    <div className="App">
      {/* Navigation */}
      <Navigation />
      
      {/* Title Bar */}
      <TitleBar />
      
      {/* Logo - Top Left */}
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="logo-container"
        style={{
          position: 'fixed',
          top: '80px',
          left: '20px',
          zIndex: 999,
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(20px)',
          borderRadius: '16px',
          padding: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          cursor: 'pointer',
          maxWidth: '180px'
        }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => window.open('https://optimizemydata.com/', '_blank')}
      >
        <img 
          src="/logo-omd.png" 
          alt="OptimizeMyData Logo"
          style={{
            height: '40px',
            width: 'auto',
            maxWidth: '160px'
          }}
        />
      </motion.div>

      {/* Lead Form - Moved to Top */}
      <LeadForm />
      
      {/* Hero Section */}
      <Hero />
      
      {/* Value Proposition Strip */}
      <ValueStrip />
      
      {/* Core Benefits */}
      <Benefits />
      
      {/* Features / What You Get */}
      <Features />
      
      {/* Process Section */}
      <Process />
      
      {/* Pricing Section */}
      <Pricing />
      
      {/* Testimonials */}
      <Testimonials />
      
      {/* FAQ Section */}
      <FAQ />
      
      {/* Footer */}
      <footer style={{
        background: '#1e293b',
        color: 'white',
        padding: '60px 0 40px',
        textAlign: 'center'
      }}>
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h3 style={{
              fontSize: '1.5rem',
              fontWeight: '700',
              marginBottom: '16px'
            }}>
              Ready to Launch Your Store in 15 Days?
            </h3>
            <p style={{
              fontSize: '1.125rem',
              opacity: 0.8,
              marginBottom: '32px',
              maxWidth: '600px',
              margin: '0 auto 32px'
            }}>
              Join 150+ businesses who've launched successfully with our proven process.
            </p>
            <a 
              href="#lead-form" 
              className="btn btn-primary"
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                marginBottom: '32px'
              }}
            >
              Get My Free Plan
            </a>
            
            <div style={{
              borderTop: '1px solid #374151',
              paddingTop: '32px',
              fontSize: '14px',
              opacity: 0.6
            }}>
              <p>© 2024 OptimizeMyData. All rights reserved.</p>
              <p style={{ marginTop: '8px' }}>
                Email: sales@optimizemydata.com | Launch-ready in 15 days • 30-day support included
              </p>
              <p style={{ marginTop: '12px' }}>
                <a 
                  href="https://optimizemydata.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{
                    color: '#667eea',
                    textDecoration: 'none',
                    fontWeight: '500'
                  }}
                >
                  Visit our main website →
                </a>
              </p>
            </div>
          </motion.div>
        </div>
      </footer>
      
      {/* Floating CTA */}
      <FloatingCTA />
    </div>
  );
}

export default App;
